import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Skill } from '@shared';

@Component({
  selector: 'mojo-candidate-skills-card',
  templateUrl: './candidate-skills-card.component.html',
  styleUrls: ['./candidate-skills-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSkillsCardComponent {
  private readonly maxSkillsDisplayed = 20;

  @Input()
  header: string;
  @Input() showCard = true;

  @Input() isNotAnonymized = true;

  @Input() fromTalentPool = false;

  @Input()
  set skills(skills: Array<Skill>) {
    this.allSkills = skills;
    this.expandable = this.shouldBeExpandable();
    this.prepareDisplayedSkills();
  }

  expandable = true;
  expanded = false;

  displayedSkills: Array<string> = new Array<string>();
  allSkills: Array<Skill> = new Array<Skill>();

  toggleCard(isExpanded) {
    this.expanded = isExpanded;
    this.prepareDisplayedSkills();
  }

  private prepareDisplayedSkills() {
    if (this.expanded) {
      this.displayedSkills = this.allSkills.map((skill) => skill.name);
    } else {
      this.displayedSkills = this.allSkills
        .slice(0, this.maxSkillsDisplayed)
        .map((skill) => skill.name);
    }
  }

  private shouldBeExpandable() {
    return this.allSkills.length > this.maxSkillsDisplayed;
  }
}
